export interface Status {
  enabled: boolean; // Should the service be running?
  running: boolean; // Is the driver running / connected now?
  capturing: boolean; // Is the driver capturing valid user data points now?
}

export abstract class DriverTemplate {
  protected myStatus: Status = {
    enabled: false,
    running: false,
    capturing: false,
  };

  /**
   * Solicita status do driver
   *
   * @returns status do driver
   */
  status() {
    return this.myStatus;
  }

  /**
   * Informa se o driver está habilitado (conectado ao hardware, etc.)
   *
   * @returns  true se está desabilitado, false se não está rodando
   */
  isEnabled() {
    return this.myStatus.enabled;
  }

  /**
   * Informa se o driver está rodando (conectado ao hardware, etc.)
   *
   * @returns  true se está rodando, false se não está rodando
   */
  isRunning() {
    return this.myStatus.running;
  }

  /**
   * Informa se o driver está capturando dados do usuário
   *
   * @returns true se está capturando, false se não está capturando
   */
  isCapturing() {
    return this.myStatus.capturing;
  }

  /**
   * callback function the driver will call when it has a result to return
   * Must be set by the service directly consuming the driver data
   */
  captureResultCallback: (result: any) => void = () => {console.log('captureResultCallback not set');};

  /**
   * Solicita inicialização do driver
   *
   * @returns true se o driver foi inicializado, false se o driver já estava inicializado
   */
  abstract start(options?: any): Promise<boolean>;

  /**
   * Solicita desligamento do driver
   *
   * @returns true se o driver foi desligado, false se o driver já estava desligado
   */
  abstract stop():  Promise<boolean>;

}
